module.exports = __webpack_public_path__ + "img/2020-06-05.ff53e57c.jpg";